import { Table, Button, message, Modal, Input } from 'antd'
import {
  BarChart,
  GridlineSeries,
  Gridline,
  BarSeries,
  Bar,
  GuideBar
} from 'reaviz'
import StudentGradeBook from './studentGB'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import gradebookService from '../../../services/gradebook'
import './../styles.css'

const SummaryTable = ({ courseId }) => {
  const [student, setStudent] = useState('')
  const [showSt, setShowst] = useState(false)
  const [vis, setVis] = useState(true)
  const [awardModal, setAwardModal] = useState({ visible: false, record: null })
  const [certificateUrl, setCertificateUrl] = useState('')
  const [awarding, setAwarding] = useState(false)

  const studentGrades = useSelector((state) => state.summaryGradebook)

  const fCol = [
    {
      title: 'Student',
      dataIndex: 'student',
      key: 'student',
      render: (text) => (
        <a
          onClick={() => {
            setStudent(text._id)
            setVis(false)
            setShowst(true)
          }}
        >
          {text.name}
        </a>
      )
    },
    {
      title: 'Assignments',
      dataIndex: 'assignmentsScore',
      key: 'assignmentsScore',
      sorter: {
        compare: (a, b) =>
          Number(a.assignmentsScore.slice(0, -1)) -
          Number(b.assignmentsScore.slice(0, -1))
      }
    },
    {
      title: 'Exams',
      dataIndex: 'examsScore',
      key: 'examsScore',
      sorter: {
        compare: (a, b) =>
          Number(a.examsScore.slice(0, -1)) - Number(b.examsScore.slice(0, -1))
      }
    },
    /*{
      title: 'Final Exam',
      dataIndex: 'finalExamsScore',
      key: 'finalExamsScore',
      sorter: {
        compare: (a, b) =>
          Number(a.finalExamsScore.slice(0, -1)) - Number(b.finalExamsScore.slice(0, -1))
      }
    },*/
    {
      title: 'Total Score',
      dataIndex: 'totalScore',
      key: 'totalScore',
      sorter: {
        compare: (a, b) =>
          Number(a.totalScore.slice(0, -1)) - Number(b.totalScore.slice(0, -1))
      }
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      key: 'grade'
    },
    {
      title: 'Achievement',
      key: 'achievement',
      render: (_, record) => {
        const studentId = record.student && record.student._id
        if (!studentId) return null
        return (
          <Button
            size="small"
            type="primary"
            ghost
            onClick={() => {
              setCertificateUrl('')
              setAwardModal({ visible: true, record })
            }}
          >
            Award achievement
          </Button>
        )
      }
    }
  ]

  const handleAwardAchievement = async () => {
    if (!awardModal.record) return
    const record = awardModal.record
    const studentId = record.student && record.student._id
    if (!studentId) return
    setAwarding(true)
    try {
      await gradebookService.awardAchievement(courseId, {
        studentId,
        score: record.totalScore,
        gradeLetter: record.grade,
        ...(certificateUrl.trim() && { certificate: certificateUrl.trim() })
      })
      message.success(`Achievement awarded to ${record.student.name}`)
      setAwardModal({ visible: false, record: null })
      setCertificateUrl('')
    } catch (e) {
      message.error(e?.response?.data?.error || 'Failed to award achievement')
    } finally {
      setAwarding(false)
    }
  }

  const calculateDistribution = (arr) => {
    var a = [],
      b = [],
      prev
    var res = []
    arr.sort(function (a, b) {
      return (
        Number(a.totalScore.slice(0, -1)) - Number(b.totalScore.slice(0, -1))
      )
    })
    for (var i = 0; i < arr.length; i++) {
      if (Number(arr[i].totalScore.slice(0, -1)) !== prev) {
        a.push(Number(arr[i].totalScore.slice(0, -1)))
        b.push(1)
      } else {
        b[b.length - 1]++
      }
      prev = Number(arr[i].totalScore.slice(0, -1))
    }

    for (var i = 0; i < a.length; i++) {
      res.push({ key: a[i] + '%', data: b[i] })
    }
    console.log(res)
    return res
  }

  return (
    <>
      {vis && (
        <>
          <div className="barRow">
            <BarChart
              className="bar1"
              width={350}
              height={250}
              data={studentGrades
                .map((v) => {
                  let res = {
                    key: v.student.name,
                    data: Number(v.totalScore.slice(0, -1))
                  }
                  return res
                })
                .sort(function (a, b) {
                  return b.data - a.data
                })}
              gridlines={<GridlineSeries line={<Gridline direction="y" />} />}
            />
            <BarChart
              className="bar2"
              width={350}
              height={250}
              data={calculateDistribution(studentGrades)}
              gridlines={<GridlineSeries line={<Gridline direction="y" />} />}
              series={
                <BarSeries
                  padding={Number('Padding', 0.1)}
                  bar={
                    <Bar
                      gradient={Bar.defaultProps.gradient}
                      guide={<GuideBar />}
                    />
                  }
                />
              }
            />
          </div>
          <Table
            rowKey={(record) => record.id}
            columns={fCol}
            dataSource={studentGrades}
            bordered
            pagination={false}
            title={() => 'students summary gradebook'}
          />
        </>
      )}
      {showSt && (
        <>
          <Button
            onClick={() => {
              setShowst(false)
              setVis(true)
              setStudent('')
            }}
          >
            Close Student Gradebook
          </Button>
          <StudentGradeBook courseId={courseId} id={student} />
        </>
      )}
      <Modal
        title="Award achievement"
        visible={awardModal.visible}
        onOk={handleAwardAchievement}
        onCancel={() => setAwardModal({ visible: false, record: null })}
        confirmLoading={awarding}
        okText="Award"
      >
        {awardModal.record && (
          <p>
            Award achievement to <strong>{awardModal.record.student?.name}</strong> (Grade: {awardModal.record.grade}, Score: {awardModal.record.totalScore}).
          </p>
        )}
        <div style={{ marginTop: 12 }}>
          <label style={{ display: 'block', marginBottom: 4 }}>Certificate URL (optional)</label>
          <Input
            placeholder="https://..."
            value={certificateUrl}
            onChange={(e) => setCertificateUrl(e.target.value)}
          />
        </div>
      </Modal>
    </>
  )
}

export default SummaryTable
